import { CircularProgress, Grid, useTheme } from "@mui/material";
import React, { useContext, useMemo } from "react";
import { UpdatingEmployeesContext } from "../TnAOverviewsTable/TnAOverviewsWrapper";

const UpdatingEmployee = ({ id }: { id: string }) => {
  const theme = useTheme();

  const { employeeIdsUpdating: employeeIdsUpdating } = useContext(UpdatingEmployeesContext);

  const employeeIsUpdating = useMemo(() => {
    return employeeIdsUpdating.includes(id);
  }, [employeeIdsUpdating, id]);

  return (
    <>
      {employeeIsUpdating && (
        <Grid sx={{ display: "flex", flexDirection: "column", gap: "2px", margin: "0px 5px 0px 0px" }}>
          <CircularProgress
            color={"primary"}
            style={{
              opacity: 0.4,
            }}
            size={10}
            title={"Updating employee's data"}
          />

          {/* <FontAwesomeIcon
            color={theme.palette.warning.main}
            icon={faExclamationTriangle}
            title={"Updating employee's data"}
          /> */}
        </Grid>
      )}
    </>
  );
};

export default UpdatingEmployee;
